import Button from '@cobliteam/ui/components/Button';
import Dialog from '@cobliteam/ui/components/Dialog';
import { cn } from '@cobliteam/ui/utils';
import { useState } from 'react';
import FlagsData from '../FlagsData';
import LocalStorageData from '../LocalStorageData';
import PermissionsData from '../PermissionsData';
import UserData from '../UserData';

type Position = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'bottom-center' | 'top-center';

const MENU_ITEMS = [
  { title: 'Meus dados', key: 'userData' },
  { title: 'Flags', key: 'flags' },
  { title: 'Permissões', key: 'permissions' },
  { title: 'LocalStorage', key: 'localStorage' },
  { title: 'Posição', key: 'position' },
];

interface DeveloperToolsDialogProps {
  open: boolean;
  onClose: () => void;
}

const DeveloperToolsDialog = ({ open, onClose }: DeveloperToolsDialogProps) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState<string>('userData');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <Dialog.Content size='lg'>
        <Dialog.Header>
          <Dialog.Title>Developer Tools</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close />
        </Dialog.Header>

        <Dialog.Body>
          <div className='flex h-[450px]'>
            <nav className='flex w-40 flex-col gap-2 border-gray-6 border-r px-2'>
              {MENU_ITEMS.map(({ title, key }) => (
                <Button
                  key={key}
                  variant='ghost'
                  color='default'
                  onClick={() => setSelectedMenuItem(key)}
                  className={cn('justify-start', {
                    'bg-gray-light': selectedMenuItem === key,
                  })}
                >
                  {title}
                </Button>
              ))}
            </nav>

            <div className='flex w-full flex-1 flex-col overflow-auto px-4'>
              {selectedMenuItem === 'userData' && <UserData />}
              {selectedMenuItem === 'flags' && <FlagsData />}
              {selectedMenuItem === 'permissions' && <PermissionsData />}
              {selectedMenuItem === 'localStorage' && <LocalStorageData />}
            </div>
          </div>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default DeveloperToolsDialog;
